module.exports = __webpack_public_path__ + "img/Habitation.739b8f82.svg";